// https://itnext.io/building-a-toggled-mask-password-input-component-w-react-and-material-ui-f55e6bd73434
import React, { Component } from 'react';
import { InputAdornment, withStyles } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import { RemoveRedEye } from '@material-ui/icons';
import PropTypes from 'prop-types';

const styles = theme => ({
  eye: {
    cursor: 'pointer',
  },
});

class PasswordInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      passwordIsMasked: true,
    };

    this.togglePasswordMask = this.togglePasswordMask.bind(this);
  }

  togglePasswordMask() {
    this.setState(prevState => ({
      passwordIsMasked: !prevState.passwordIsMasked,
    }));
  };

  render() {
    const {
      classes,
    } = this.props;
    const {
      passwordIsMasked,
    } = this.state;

    return (
      <TextField
        className="password-input"
        type={passwordIsMasked ? 'password' : 'text'}
        {...this.props}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <RemoveRedEye
                className={classes.eye}
                onClick={this.togglePasswordMask}
              />
            </InputAdornment>
          ),
        }}
      />
    );
  }
}

export default withStyles(styles)(PasswordInput);
